import { Box } from "@mui/material"

// Small "New" pill shown on a comment thread / row that has content the viewer has not read yet.
// Matches the red tab badge so the thread the badge is counting is obvious at a glance.
export function CommentNewMarker() {
    return (
        <Box
            component="span"
            data-cy="share-comment-new-marker"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                height: 16,
                px: 0.75,
                borderRadius: 999,
                bgcolor: "error.main",
                color: "error.contrastText",
                fontSize: 9.5,
                fontWeight: 700,
                letterSpacing: 0.4,
                textTransform: "uppercase",
            }}
        >
            New
        </Box>
    )
}
